import { motion } from "framer-motion";
import { Quote } from "lucide-react";

// Real client testimonials supplied by Faisal, Dec 2025.
const TESTIMONIALS = [
  {
    quote:
      "We'd been trying to break into three new regional markets for years with no success. The AI-powered outreach and lead generation system Faisal built for us identified the right contacts, ran the sequences, and booked the meetings. Six months later our order book is 42.3% larger and we're now active in all three regions.",
    company: "Groundworks Contractor",
    location: "Midlands",
    stat: "+40% order book growth",
  },
  {
    quote:
      "The C180 AI system gave our Commercial and BD team a structure they'd never had. The AI handles the sequencing and follow-up, we show up to qualified meetings. Within 90 days we'd secured two framework agreements and added over £800K in contracted revenue. The ROI is undeniable.",
    company: "MEP Contractor",
    location: "Manchester",
    stat: "+£800K contracted revenue",
  },
  {
    quote:
      "We tried outsourcing lead generation before, it never stuck. I met Faisal last year and was wowed by the results. The C180 AI system is structured, consistent, and doesn't drop the ball on follow-up. Our pipeline has been full for 8 months straight and we've gone from 11% to 58% above revenue target. Highly recommend.",
    company: "Main Contractor",
    location: "West London",
    stat: "+58% above revenue target",
  },
  {
    quote:
      "Operating in the UAE market requires precision targeting and a flawless sales engine, Faisal's team delivered both. Our outreach and automation layers are now intelligent, sequenced, and scalable. We've added £1.5M in new revenue this year from clients his system built for us. His knowledge is by far the best I've seen in Construction.",
    company: "Building Consultancy",
    location: "UAE",
    stat: "+£1.5M new revenue",
  },
  {
    quote:
      "We were completely reliant on word-of-mouth before Peak One. The AI outreach system opened doors into commercial sectors we couldn't access manually. Project bookings are up 40% and we now have a real pipeline for the first time in 12 years of trading. If you need to install AI systems, Faisal is your man.",
    company: "Drylining & Joinery",
    location: "East London",
    stat: "+40% project bookings",
  },
  {
    quote:
      "Faisal's team didn't just generate leads, they replaced an entire Business Development function. The automated sequences, CRM integration, dashboard, reactivation sequence and targeted messaging freed us up to focus on delivery. Revenue went from £1.2M to £2.5M in 4 months and we didn't need to hire anyone to do it.",
    company: "Electrical Contractor",
    location: "Essex",
    stat: "£1.2M → £2.5M in 4 months",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="relative py-24 md:py-32"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-12 lg:px-16">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div>
            <div className="text-xs font-mono uppercase tracking-[0.2em] text-[#00E5FF]">
              / Client outcomes
            </div>
            <h2 className="font-heading text-4xl md:text-5xl font-bold tracking-tighter mt-4 max-w-2xl">
              Revenue moved. Pipelines unlocked.
            </h2>
          </div>
          <p className="text-white/55 max-w-sm text-sm font-mono uppercase tracking-wider">
            From 80+ engagements across construction, property &amp; professional services
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.45, delay: (i % 3) * 0.08 }}
              className="bg-[#050505] p-8 md:p-9 flex flex-col"
            >
              <div className="flex items-start justify-between gap-4">
                <Quote className="h-5 w-5 text-[#00E5FF] shrink-0" />
                <div
                  data-testid={`testimonial-${i}-stat`}
                  className="font-mono text-[10px] uppercase tracking-widest text-[#00E5FF] border border-[#00E5FF]/40 bg-[#00E5FF]/[0.06] px-2.5 py-1 text-right max-w-[60%]"
                >
                  {t.stat}
                </div>
              </div>

              <blockquote className="font-heading text-[17px] md:text-[18px] font-medium leading-snug tracking-tight text-white/90 mt-6 flex-1">
                &ldquo;{t.quote}&rdquo;
              </blockquote>

              <figcaption className="mt-8 pt-5 border-t border-white/10">
                <div className="text-sm text-white font-medium">{t.company}</div>
                <div className="font-mono text-[11px] uppercase tracking-widest text-white/50 mt-1">
                  {t.location}
                </div>
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
